// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2taC2","selects":"Documents_selects__3K89X"};